import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {BaseLayoutComponent} from './Layout/base-layout/base-layout.component';
import {PagesLayoutComponent} from './Layout/pages-layout/pages-layout.component';

// DEMO PAGES

// Dashboards

import {AnalyticsComponent} from './DemoPages/Dashboards/analytics/analytics.component';

// Pages

import {ForgotPasswordBoxedComponent} from './DemoPages/UserPages/forgot-password-boxed/forgot-password-boxed.component';
import {LoginBoxedComponent} from './DemoPages/UserPages/login-boxed/login-boxed.component';
import {RegisterBoxedComponent} from './DemoPages/UserPages/register-boxed/register-boxed.component';

// Elements

import {StandardComponent} from './DemoPages/Elements/Buttons/standard/standard.component';
import {DropdownsComponent} from './DemoPages/Elements/dropdowns/dropdowns.component';
import {CardsComponent} from './DemoPages/Elements/cards/cards.component';
import {ListGroupsComponent} from './DemoPages/Elements/list-groups/list-groups.component';
import {TimelineComponent} from './DemoPages/Elements/timeline/timeline.component';
import {IconsComponent} from './DemoPages/Elements/icons/icons.component';

// Components

import {AccordionsComponent} from './DemoPages/Components/accordions/accordions.component';
// import {TabsComponent} from './DemoPages/Components/tabs/tabs.component';
import {CarouselComponent} from './DemoPages/Components/carousel/carousel.component';
import {ModalsComponent} from './DemoPages/Components/modals/modals.component';
import {ProgressBarComponent} from './DemoPages/Components/progress-bar/progress-bar.component';
import {PaginationComponent} from './DemoPages/Components/pagination/pagination.component';
import {TooltipsPopoversComponent} from './DemoPages/Components/tooltips-popovers/tooltips-popovers.component';

// Tables

import {TablesMainComponent} from './DemoPages/Tables/tables-main/tables-main.component';

// Widgets

import {ChartBoxes3Component} from './DemoPages/Widgets/chart-boxes3/chart-boxes3.component';

// Forms Elements

import {ControlsComponent} from './DemoPages/Forms/Elements/controls/controls.component';
import {LayoutComponent} from './DemoPages/Forms/Elements/layout/layout.component';

// Charts

import {ChartjsComponent} from './DemoPages/Charts/chartjs/chartjs.component';
import { UsersComponent } from '../app/users/users.component'
import { DriversComponent } from './drivers/drivers.component';
import { VehicleComponent } from './vehicle/vehicle.component';
import { PackageComponent } from './package/package.component';
import { PaymentsComponent } from './payments/payments.component';
import { CityComponent } from './city/city.component';
import { BusinessComponent } from './business/business.component';
import { SettingComponent } from './setting/setting.component';
import {  AuthGuard } from './auth.guard'
import { ActiveDriversComponent } from './active-drivers/active-drivers.component';
import { AddDriversComponent } from './add-drivers/add-drivers.component';
import { AddVehiclesComponent } from './add-vehicles/add-vehicles.component';
import { AddPackageComponent } from './add-package/add-package.component';
import { AddAdminComponent } from './add-admin/add-admin.component';
import { AdminComponent } from './admin/admin.component';
import { ViewUserDetailsComponent } from './view-user-details/view-user-details.component';
import { ViewVehicleDetailsComponent } from './view-vehicle-details/view-vehicle-details.component';
import { ViewPackageDetailsComponent } from './view-package-details/view-package-details.component';
import { EditPackageComponent } from './edit-package/edit-package.component';
import { VehicleBookingComponent } from './vehicle-booking/vehicle-booking.component';
import { PickDropRequestComponent } from './pick-drop-request/pick-drop-request.component';
import { PackerMoverRequestComponent } from './packer-mover-request/packer-mover-request.component';
import { DriverPartnerRequestComponent } from './driver-partner-request/driver-partner-request.component';
import { EnterpriseRequestComponent } from './enterprise-request/enterprise-request.component';
import { ViewPackerMoverRequestComponent } from './view-packer-mover-request/view-packer-mover-request.component';
import { VendorComponent } from './vendor/vendor.component';
import { UploadComponent } from './upload/upload.component';
import { TrackAllPackagesComponent } from './track-all-packages/track-all-packages.component';
import { PackageTrackComponent } from './package-track/package-track.component';
import { QrConfigComponent } from './qr-config/qr-config.component';
import { QrConfigTableComponent } from './qr-config-table/qr-config-table.component';
import { PackageConfigurationComponent } from './configuration/packageConfiguration/package-configuration/package-configuration.component';
import { GetPackageConfigComponent } from './configuration/packageConfiguration/get-package-config/get-package-config.component';
import { ViewAndUpdateConfigComponent } from './configuration/view-and-update-config/view-and-update-config.component';
import { AddConfigurationComponent } from './configuration/add-configuration/add-configuration.component';
import { DriverWithdrawalRequestComponent } from './driver-withdrawal-request/driver-withdrawal-request.component';
import { DriverWalletComponent } from './driver-wallet/driver-wallet.component';
import { DriverDepositeTransactionComponent } from './driver-deposite-transaction/driver-deposite-transaction.component';
//settings

//Vacant Vehicle routes
// import { VcPostAddListComponent } from './Vacant-Vehicle-Pages/vc-post-add-list/vc-post-add-list.component';
// import { ViewPostAddComponent } from './Vacant-Vehicle-Pages/view-post-add/view-post-add.component';
import { SubscriptionListComponent } from './Subscription/subscription-list/subscription-list.component';
import { TruckTyresComponent } from './vacantVehicle/truck-tyres/truck-tyres.component';

import { VehiclesComponent } from './vacantVehicle/vehicles/vehicles.component';
import { DriverPostAddComponent } from './vacantVehicle/postAdds/driver-post-add/driver-post-add.component';
import { UserPostAddComponent } from './vacantVehicle/postAdds/user-post-add/user-post-add.component';
import { PostLoadComponent } from './vacantVehicle/postAdds/post-load/post-load.component';
import { PostVacantVehicleComponent } from './vacantVehicle/postAdds/post-vacant-vehicle/post-vacant-vehicle.component';
import { SupportRequestsComponent } from './support-requests/support-requests.component';
import { BidsComponent } from './vacantVehicle/bids/bids.component';
import { DriverReviewsComponent } from './driver-reviews/driver-reviews.component';
import { DriverLoadAlertComponent } from './vacantVehicle/driver-load-alert/driver-load-alert.component';
import { OnlineDriversComponent } from './online-drivers/online-drivers.component';
import { UserEnterpriseRequestsComponent } from './Enterprise/user-enterprise-requests/user-enterprise-requests.component';
import { ViewEnterpriseDetailsComponent } from './Enterprise/view-enterprise-details/view-enterprise-details.component';
import { SubscriptionPlansComponent } from './Enterprise/Subscription/subscription-plans/subscription-plans.component';
import { EmployeeRequestsComponent } from './Enterprise/employee-requests/employee-requests.component';
import { BranchRequestsComponent } from './Enterprise/branch-requests/branch-requests.component';
import { TripsComponent } from './Enterprise/Trips/trips/trips.component';
import { ViewTripsComponent } from './Enterprise/Trips/view-trips/view-trips.component';
import { TrackTripComponent } from './Enterprise/Trips/track-trip/track-trip.component';
import { UserWithdrwalRequestsComponent } from './userWallet/user-withdrwal-requests/user-withdrwal-requests.component';
import { UserTransactionsComponent } from './userWallet/user-transactions/user-transactions.component';
import { UserDepositsComponent } from './userWallet/user-deposits/user-deposits.component';
import { EnterprisesComponent } from './Enterprise/enterprises/enterprises.component';
import { EnterpriseDashboardComponent } from './Enterprise/enterprise-dashboard/enterprise-dashboard.component';
import { ViewLoadComponent } from './vacantVehicle/postAdds/view-load/view-load.component';
import { UserLoadAlertComponent } from './vacantVehicle/user-load-alert/user-load-alert.component';
import { GetPackersMoversListComponent } from './packersMovers/get-packers-movers-list/get-packers-movers-list.component';
import { ViewPackersMoversComponent } from './packersMovers/view-packers-movers/view-packers-movers.component';
import { GetUserDetailsComponent } from './packersMovers/get-user-details/get-user-details.component';
import { ViewUsersDetailsComponent } from './packersMovers/view-users-details/view-users-details.component';
import { ViewNotificationHistoryComponent } from './notifications/view-notification-history/view-notification-history.component';
import { SendPushNotificationComponent } from './notifications/send-push-notification/send-push-notification.component';
import { WarehouseListComponent } from './warehouse/warehouse-list/warehouse-list.component';
import { ViewWarehouseComponent } from './warehouse/view-warehouse/view-warehouse.component';
import { UserVacantVehicleSearchListComponent } from './vacantVehicle/searchNotification/user-vacant-vehicle-search-list/user-vacant-vehicle-search-list.component';
import { UserViewVacantVehicleSearchComponent } from './vacantVehicle/searchNotification/user-view-vacant-vehicle-search/user-view-vacant-vehicle-search.component';
import { DriverLoadSearchListComponent } from './vacantVehicle/searchNotification/driver-load-search-list/driver-load-search-list.component';
import { DriverViewLoadSearchComponent } from './vacantVehicle/searchNotification/driver-view-load-search/driver-view-load-search.component';

const routes: Routes = [
  { path : "" , redirectTo:"/dashboard", pathMatch:"full"},
  {path : "login" , component:LoginBoxedComponent},
  {
    path: 'dashboard',
    component: BaseLayoutComponent,canActivate:[AuthGuard],
    children: [

      // Dashboads

      {path: '', component: AnalyticsComponent, data: {extraParameter: 'dashboardsMenu'}},

      // Elements

      {path: 'elements/buttons-standard', component: StandardComponent, data: {extraParameter: 'elementsMenu'}},
      {path: 'elements/dropdowns', component: DropdownsComponent, data: {extraParameter: 'elementsMenu'}},
      {path: 'elements/icons', component: IconsComponent, data: {extraParameter: 'elementsMenu'}},
      {path: 'elements/cards', component: CardsComponent, data: {extraParameter: 'elementsMenu'}},
      {path: 'elements/list-group', component: ListGroupsComponent, data: {extraParameter: 'elementsMenu'}},
      {path: 'elements/timeline', component: TimelineComponent, data: {extraParameter: 'elementsMenu'}},

      // Components

      // {path: 'components/tabs', component: TabsComponent, data: {extraParameter: 'componentsMenu'}},
      {path: 'components/accordions', component: AccordionsComponent, data: {extraParameter: 'componentsMenu'}},
      {path: 'components/modals', component: ModalsComponent, data: {extraParameter: 'componentsMenu'}},
      {path: 'components/progress-bar', component: ProgressBarComponent, data: {extraParameter: 'componentsMenu'}},
      {path: 'components/tooltips-popovers', component: TooltipsPopoversComponent, data: {extraParameter: 'componentsMenu'}},
      {path: 'components/carousel', component: CarouselComponent, data: {extraParameter: 'componentsMenu'}},
      {path: 'components/pagination', component: PaginationComponent, data: {extraParameter: 'componentsMenu'}},

      // Tables

      {path: 'tables/bootstrap', component: TablesMainComponent, data: {extraParameter: 'tablesMenu'}},

      // Widgets

      {path: 'widgets/chart-boxes-3', component: ChartBoxes3Component, data: {extraParameter: 'pagesMenu3'}},

      // Forms Elements

      {path: 'forms/controls', component: ControlsComponent, data: {extraParameter: 'formElementsMenu'}},
      {path: 'forms/layouts', component: LayoutComponent, data: {extraParameter: 'formElementsMenu'}},

      // Charts

      {path: 'charts/chartjs', component: ChartjsComponent, data: {extraParameter: ''}},

      { path:'users' , component: UsersComponent ,data: {extraParameter: ''}},
      { path:'viewUserDetails' , component: ViewUserDetailsComponent ,data: {extraParameter: ''}},
      { path:'drivers' , component: DriversComponent ,data: {extraParameter: ''}},
      { path:'online-drivers', component:OnlineDriversComponent, data: {extraParameter:''}},
      { path:'activeDrivers' , component: ActiveDriversComponent ,data: {extraParameter: ''}},
      { path:'addDrivers' , component: AddDriversComponent ,data: {extraParameter: ''}},
      { path:'vehicle' , component: VehicleComponent ,data: {extraParameter: ''}},
      { path:'viewVehicleDetails' , component: ViewVehicleDetailsComponent ,data: {extraParameter: ''}},
      { path:'addVehicle' , component: AddVehiclesComponent ,data: {extraParameter: ''}},
      { path:'package' , component: PackageComponent ,data: {extraParameter: ''}},
      { path:'viewPackageDetails' , component: ViewPackageDetailsComponent ,data: {extraParameter: ''}},
      { path:'editPackage' , component: EditPackageComponent ,data: {extraParameter: ''}},
      { path:'addPackage' , component: AddPackageComponent ,data: {extraParameter: ''}},
      { path:'trackPackage' , component: PackageTrackComponent ,data: {extraParameter: ''}},
      { path:'trackAllPackages' , component: TrackAllPackagesComponent ,data: {extraParameter: ''}},
      { path:'payments' , component: PaymentsComponent ,data: {extraParameter: ''}},
      { path:'city' , component: CityComponent ,data: {extraParameter: ''}},
      { path:'business' , component: BusinessComponent ,data: {extraParameter: ''}},
      { path:'admin' , component: AdminComponent ,data: {extraParameter: ''}},
      { path:'addAdmin' , component: AddAdminComponent ,data: {extraParameter: ''}},
      { path:'setting' , component: SettingComponent ,data: {extraParameter: ''}},
      {path: 'pages/register-boxed', component: RegisterBoxedComponent, data: {extraParameter: ''}},
      {path: 'vehicleBooking', component: VehicleBookingComponent, data: {extraParameter: ''}},
      {path: 'pickDropRequest', component: PickDropRequestComponent, data: {extraParameter: ''}},
      {path: 'packerMoverRequest', component: PackerMoverRequestComponent, data: {extraParameter: ''}},
      {path: 'viewPackerMoverRequest', component: ViewPackerMoverRequestComponent, data: {extraParameter: ''}},
      {path: 'driverPartnerRequest', component: DriverPartnerRequestComponent, data: {extraParameter: ''}},
      {path: 'enterpriseRequest', component: EnterpriseRequestComponent, data: {extraParameter: ''}},
      {path: 'vendor', component: VendorComponent, data: {extraParameter: ''}},
      {path: 'upload', component: UploadComponent, data: {extraParameter: ''}},
      {path: 'addqrConfigration', component:QrConfigComponent, data:{extraParameter: ''}},
      {path: 'qrConfigration', component:QrConfigTableComponent, data:{extraParameter:''} },
      {path: 'addPackageConfiguration', component:PackageConfigurationComponent, data:{extraParameter:''} },
      {path: 'packageConfiguration', component:GetPackageConfigComponent, data:{extraParameter:''}},
      {path: 'configuration', component:ViewAndUpdateConfigComponent, data:{extraParameter:''}},
      {path: 'addConfiguration', component:AddConfigurationComponent, data:{extraParameter:''}},

      // Wallet withdrawal Request
      {path: 'driverWithdrawalRequest', component:DriverWithdrawalRequestComponent, data:{extraParameter:''}},
      {path: 'driver/wallet', component: DriverWalletComponent, data:{extraParameter:''}},
      {path: 'driver/deposite/transaction', component: DriverDepositeTransactionComponent, data:{extraParameter:''}},

      {path: 'user-withdrawal-requests', component:UserWithdrwalRequestsComponent, data:{extraParameter:''}},
      {path: 'user/wallet', component: UserTransactionsComponent, data:{extraParameter:''}},
      {path: 'user/deposite/transaction', component: UserDepositsComponent, data:{extraParameter:''}},
      //Vacant Vehicle 
      // {path: 'view-post-add-list', component: VcPostAddListComponent, data:{extraParameter:''}},
      // {path: 'view-post-add', component: ViewPostAddComponent, data:{extraParameter:''}},

      {path: 'view-subscription-list', component: SubscriptionListComponent, data:{extraParameter:''}},

      
      {path: 'vacant-vehicles', component: VehiclesComponent, data:{extraParameter:''}},
      {path: 'truck-tyres', component: TruckTyresComponent, data:{extraParameter:''}},

      {path: 'driver-post-adds', component: DriverPostAddComponent, data:{extraParameter:''}},
      {path: 'user-post-adds', component: UserPostAddComponent, data:{extraParameter:''}},

      {path: 'post-load', component: PostLoadComponent, data:{extraParameter:''}},
      {path: 'post-vacant-vehicle', component: PostVacantVehicleComponent, data:{extraParameter:''}},
      {path: 'view-load', component: ViewLoadComponent, data:{extraParameter:''}},
      {path: 'bids', component: BidsComponent, data:{extraParameter:''}},
      {path: 'support', component: SupportRequestsComponent, data:{extraParameter:''}},
      {path:  'driver-reviews', component:DriverReviewsComponent, data:{extraParameter:''}},
      {path:  'driver-load-alerts', component:DriverLoadAlertComponent, data:{extraParameter:''}},
      {path:  'user-load-alerts', component:UserLoadAlertComponent, data:{extraParameter:''}},
      {path:  'user-vacant-vehicle-search', component:UserVacantVehicleSearchListComponent, data:{extraParameter:''}},
      {path:  'user-view-vacant-vehicle-search', component:UserViewVacantVehicleSearchComponent, data:{extraParameter:''}},
      {path:  'driver-load-search', component:DriverLoadSearchListComponent, data:{extraParameter:''}},
      {path:  'driver-view-load-search', component:DriverViewLoadSearchComponent, data:{extraParameter:''}},
      // website packers movers request
      {path:  'website-packers-movers-users', component:GetUserDetailsComponent, data:{extraParameter:''}},
      {path:  'view-website-packers-movers-user', component:ViewUsersDetailsComponent, data:{extraParameter:''}},
      {path:  'website-packers-movers-requests', component:GetPackersMoversListComponent, data:{extraParameter:''}},
      {path:  'view-website-packers-movers', component:ViewPackersMoversComponent, data:{extraParameter:''}},

      // Enterpise routes
      {path:  'enterprises', component:EnterprisesComponent, data:{extraParameter:''}},
      {path:  'enterprise-dashboard', component:EnterpriseDashboardComponent, data:{extraParameter:''}},

      {path:  'user-enterprise-requests', component:UserEnterpriseRequestsComponent, data:{extraParameter:''}},
      {path:  'view-enterprise-details', component:ViewEnterpriseDetailsComponent, data:{extraParameter:''}},
      {path:  'enterprise-subscription-plans', component:SubscriptionPlansComponent, data:{extraParameter:''}},

      {path:  'enterprise-employee-requests', component:EmployeeRequestsComponent, data:{extraParameter:''}},
      {path:  'enterprise-branch-requests', component:BranchRequestsComponent, data:{extraParameter:''}},

      {path:  'enterprise-trips', component:TripsComponent, data:{extraParameter:''}},
      {path:  'enterprise-view-trip', component:ViewTripsComponent, data:{extraParameter:''}},
      {path:  'enterprise-track-trip', component:TrackTripComponent, data:{extraParameter:''}},

      // Push Notification routes
      {path:  'send-notification', component:SendPushNotificationComponent, data:{extraParameter:''}},
      {path:  'view-notification-history', component:ViewNotificationHistoryComponent, data:{extraParameter:''}},

      // warehouse routes
      {path:  'warehouse-requirements', component:WarehouseListComponent, data:{extraParameter:''}},
      {path:  'view-warehouse-requirements', component:ViewWarehouseComponent, data:{extraParameter:''}},
    ]

  },
  {
    path: '',
    component: PagesLayoutComponent,
    children: [

      // User Pages

      {path: 'pages/login-boxed', component: LoginBoxedComponent, data: {extraParameter: ''}},
      {path: 'pages/register-boxed', component: RegisterBoxedComponent, data: {extraParameter: ''}},
      {path: 'pages/forgot-password-boxed', component: ForgotPasswordBoxedComponent, data: {extraParameter: ''}},
    ]
  },
  {path: '**', redirectTo: ''}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    relativeLinkResolution: 'legacy'
})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
